import {
  withCompPreviewProps,
  createComponentPreviewMapperModel,
  withCompPreviewInfo,
} from '@wix/editor-elements-integrations';
import {
  MediaContainerDefinition,
  MediaContainerProps,
  MediaCSSVars,
} from '@wix/thunderbolt-components-native';

const getFillLayersPreviewProps = (
  carmiData: MediaContainerProps,
  { isPlayingAllowed }: { isPlayingAllowed: boolean },
) => {
  const { fillLayers } = carmiData;
  if (fillLayers.video) {
    const { videoInfo } = fillLayers.video;
    videoInfo.autoPlay = videoInfo.autoPlay && isPlayingAllowed;
    fillLayers.video.videoInfo = { ...videoInfo };
    return {
      ...carmiData,
      fillLayers: { ...fillLayers },
      previewWrapperProps: {
        autoPlayVideo: videoInfo.autoPlay,
        isPlayingAllowed,
      },
    };
  }
  return carmiData;
};

export const props = withCompPreviewProps<
  MediaContainerProps,
  MediaContainerDefinition,
  MediaContainerProps
>()(
  ['isPlayingAllowed'],
  ({ isPlayingAllowed }, carmiData: MediaContainerProps) => {
    return getFillLayersPreviewProps(carmiData, {
      isPlayingAllowed,
    });
  },
);

export const css = withCompPreviewInfo<
  MediaCSSVars,
  MediaContainerDefinition,
  MediaCSSVars
>()(['renderFixedPositionBackgrounds'], (deps, carmiData) => {
  const position = carmiData['--fill-layer-background-media-position'];
  if (position) {
    const isFixed = position === 'fixed' && deps.renderFixedPositionBackgrounds;
    return {
      ...carmiData,
      '--fill-layer-background-media-position': isFixed ? 'fixed' : 'absolute',
    };
  }
  return carmiData;
});

export default createComponentPreviewMapperModel({ props, css });
